var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebApps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.59,155.022c-31.028-20.162-9.947-39.817-9.947-39.817s-21.081,3.677-21.469,26.247c0,0-2.365,26.46,31.123,56.506l.353.278.306-.293c33.489-30.048,31.125-56.506,31.125-56.506.487-22.126-21.469-26.247-21.469-26.247s21.154,17.532-9.947,39.817Z",
    fill: "#83D989"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167.5.716H31.961A12.745,12.745,0,0,0,19.228,13.449V71.72A12.745,12.745,0,0,0,31.961,84.453H93.926V95.541H69a5.788,5.788,0,1,0,0,11.575h60.776a5.788,5.788,0,1,0,0-11.575H105.5V84.453h62A12.746,12.746,0,0,0,180.231,71.72V13.449A12.746,12.746,0,0,0,167.5.716Zm1.158,71a1.16,1.16,0,0,1-1.158,1.158H31.961A1.16,1.16,0,0,1,30.8,71.72V13.449a1.16,1.16,0,0,1,1.158-1.157H167.5a1.16,1.16,0,0,1,1.158,1.157Z",
    fill: "#83D989"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebApps);
export default __webpack_public_path__ + "static/media/web-apps.e98b00384a2c4baeee4dfca0f695f0c8.svg";
export { ForwardRef as ReactComponent };